import { Avatar, Box, TableContainer } from '@mui/material';
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const LayoutWrapper = styled(Box)(({ theme }) => {
  return css`
    display: flex;
    flex: 1;
    flex-direction: column;
    width: calc(100% - 240px);

    @media (max-width: 1000px) {
    }
  `;
});

export const AvatarWrapper = styled(Box)(({ theme }) => {
  return css`
    position: relative;
    display: flex;
    align-items: center;

    .avatar {
      width: 40px;
      height: 40px;
      font-size: 0.875rem;
      font-weight: 500;
      margin-right: 0.75rem;
      background-color: ${theme.palette.background.blueBackground};
    }
  `;
});

export const BorderedBox = styled(Box)(({ theme }) => {
  return css`
    position: relative;
    width: max-content;
    display: flex;
    border: 2px solid ${theme.palette.primary.light};
    padding: 4px 10px;
    font-size: 0.75rem;
    font-weight: 500;
    color: ${theme.palette.primary.light};
    border-radius: 1.2rem;
  `;
});

export const DataTableWrapper = styled(TableContainer)(({ theme }) => {
  return css`
    position: relative;
    padding-bottom: 20px;

    .table {
      position: relative;

      .table_head {
        background-color: ${theme.palette.background.lightBackground};

        .table_row {
          .table_data {
            font-size: 0.75rem;
            font-weight: 500;
            text-transform: uppercase;
            color: ${theme.palette.text.primary};
          }
        }
      }

      .table_body {
        .table_row {
          .table_data {
            /* display: flex;
            align-items: center; */
          }
        }
      }
    }
  `;
});

export const NumberInputWrapper = styled(Box)(({ theme }) => {
  return css`
    width: 100%;

    input[type='number'] {
      /* Remove arrows on Chrome / Safari */
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Remove arrows on Firefox */
      -moz-appearance: textfield;
    }
  `;
});
